import * as React from 'react';
import * as PropTypes from 'prop-types';
import { useState, useEffect, useRef } from 'react';
import {
  Wrapper,
  IconWrapper,
  IconSelected,
  ItemIcon,
  Tooltip,
  ComponentWrapper
} from './styled';

export interface Props {
  selected?: boolean;
  icon?: any;
  tooltip?: string;
  onClick?: Function;
  renderComponent?: Function;
}

export const Item: React.FC<Props> = ({
  selected,
  icon,
  tooltip,
  onClick,
  renderComponent
}) => {
  
  const [ isOpen, setIsOpen ] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  });

  const handleOutsideClick = (e) => {
    const isOutside = !ref.current.contains(e.target);
    isOutside && setIsOpen(false);
  };

  const handleClick = (e) => {
    renderComponent && setIsOpen(true);
    onClick && onClick(e);
  };

  return(
    <Wrapper ref={ref} onClick={ e => handleClick(e) }>
      <IconWrapper>
        { selected && <IconSelected /> }
        <ItemIcon {...icon} />
        { (tooltip && !isOpen) && (<Tooltip>{tooltip}</Tooltip>) }
      </IconWrapper>
      { (renderComponent && isOpen) && (
        <ComponentWrapper>{renderComponent()}</ComponentWrapper>
      )}
    </Wrapper>
  );
};

Item.propTypes = {
  selected: PropTypes.bool,
  icon: PropTypes.any,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
  renderComponent: PropTypes.func
};

Item.displayName = 'Item';